import React from 'react';

import FlexContainer from '@components/FlexContainer/FlexContainer';

import './IconBar.scss';

const IconBar = () => (
  <div className="icon-bar">
    <FlexContainer>
      <div className="icon-bar__container">
        <div className="icon-bar__item">
          <div className="icon-bar__icon-wrapper">
            <div className="icon-bar__icon-shadow icon-bar__icon-shadow--mobile" />
            <img
              src="/icons/phone.svg"
              alt="mobile"
              className="icon-bar__icon"
            />
          </div>
          <div className="icon-bar__text">
            Mobile
          </div>
        </div>
        <div className="icon-bar__item">
          <div className="icon-bar__icon-wrapper">
            <div className="icon-bar__icon-shadow icon-bar__icon-shadow--chart" />
            <img
              src="/icons/chart.svg"
              alt="chart"
              className="icon-bar__icon"
            />
          </div>
          <div className="icon-bar__text">
            Flexible reporting
          </div>
        </div>
        <div className="icon-bar__item">
          <div className="icon-bar__icon-wrapper">
            <div className="icon-bar__icon-shadow icon-bar__icon-shadow--shield" />
            <img
              src="/icons/shield.svg"
              alt="shield"
              className="icon-bar__icon"
            />
          </div>
          <div className="icon-bar__text">
            Secure
          </div>
        </div>
      </div>
    </FlexContainer>
  </div>
);

export default IconBar;



// WEBPACK FOOTER //
// ./src/routes/Landing/components/IconBar/IconBar.js